// extracted by mini-css-extract-plugin
module.exports = {"main-component":"skill_main-component__XYDrJ"};